import { Component, Input, OnInit } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { CalendarEvent, CalendarEventFeedback, CalendarEventFeedbackStatus, CoreLibService, LinkOpenMode, Query } from 'core-lib';
import { environment } from 'projects/appointment-module/src/environments/environment';

@Component({
    selector: 'app-event-feedback-overview',
    templateUrl: './event-feedback-overview.component.html',
    styleUrl: './event-feedback-overview.component.scss',
    standalone: false
})
export class EventFeedbackOverviewComponent implements OnInit {

  @Input() context: {
    event: CalendarEvent;
    writePermission: boolean;
  }

  feedbacks: CalendarEventFeedback[] = [];
  filteredFeedbacks: CalendarEventFeedback[] = [];
  apiURL = environment.apiURL;
  feedbackType = CalendarEventFeedbackStatus;

  statistics: { [key in CalendarEventFeedbackStatus]: number } = {
    [CalendarEventFeedbackStatus.Pending]: 0,
    [CalendarEventFeedbackStatus.Maybe]: 0,
    [CalendarEventFeedbackStatus.Negative]: 0,
    [CalendarEventFeedbackStatus.Positive]: 0
  };
  QUERY_FEEDBACK = gql`
  query listEventFeedback($eventId: ID!){
      listEventFeedback(eventId : $eventId){
          id
          comment
          creationDate
          client{
            firstname
            name
            phoneMobile
            id
            email
          }
          status
  }}`;
  constructor(public coreLibService: CoreLibService, private apollo: Apollo) {

  }
  
  ngOnInit(): void {
    this.apollo.query<Query>({
      query: this.QUERY_FEEDBACK,
      variables: {
        eventId: this.context.event.id
      }
    }).subscribe((result) => {
      if (!result.errors) {
        this.feedbacks = result.data.listEventFeedback;
        for (const feedback of this.feedbacks){
          this.statistics[feedback.status]++;
        }
        this.filteredFeedbacks = [...this.feedbacks];
      }
    });
  }

  onMailTargetClient(email: String) {
    window.location.href = `mailto:${email}`;
  }

  onPhoneTargetClient(phone: String) {
    window.location.href = `tel:${phone}`;
  }

  onSearchBarKeyUp(eventTarget: EventTarget): void {
    let target = eventTarget as HTMLInputElement;
    let value: string = target.value;
    this.filteredFeedbacks = this.feedbacks;
    value = value.toLowerCase();

    this.filteredFeedbacks = this.filteredFeedbacks.filter((feedback) => {
      let matches = false;
      if (feedback.client && feedback.client.name.toLowerCase().includes(value) || feedback.client.firstname.toLowerCase().includes(value)) {
        matches = true;
      }
      return matches;
    });
  }

  onOpenChatWithUser(userProfileId): void {
    window.open("directchat://" + userProfileId)
  }
  onExportToExcel() {
    const url = `${this.apiURL}/file-api/calendar-event/${this.context.event.id}/feedback-list?access_token=${this.coreLibService.getJWTToken()}`;
    this.coreLibService.openLink(url, LinkOpenMode.External,null);
  }
}
